// Get the favorite customerId from localStorage
export const getFavoriteCustomerId = (userId = ""): string | null => {
  const stored = localStorage.getItem(`favorite_customers_${userId}`);
  if (!stored) {
    return null;
  }
  try {
    return JSON.parse(stored) as string;
  } catch {
    return null;
  }
};

// Set a customerId as favorite
const setFavoriteCustomerId = (userId: string, customerId: string): void => {
  localStorage.setItem(
    `favorite_customers_${userId}`,
    JSON.stringify(customerId)
  );
};

// Remove the favorite customerId
const removeFavoriteCustomerId = (userId = ""): void => {
  localStorage.removeItem(`favorite_customers_${userId}`);
};

// Toggle favorite: returns true if now favorited, false if unfavorited
export const toggleFavoriteCustomerId = (
  userId = "",
  customerId: string
): boolean => {
  const current = getFavoriteCustomerId(userId);

  if (current === customerId) {
    // Already favorited - remove it
    removeFavoriteCustomerId(userId);
    return false;
  } else {
    // Not favorited or different customer - set as favorite
    setFavoriteCustomerId(userId, customerId);
    return true;
  }
};
